import script from "./FileExports.vue?vue&type=script&setup=true&lang=js"
export * from "./FileExports.vue?vue&type=script&setup=true&lang=js"

import "./FileExports.vue?vue&type=style&index=0&id=569e2a6b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-569e2a6b"]])

export default __exports__